exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-message {\n  z-index: 10000 !important;\n}\n.el-dialog__header {\n  /* background-color: rgba(50, 65, 87, .9); */\n}\n.el-dialog__title {\n  color: white;\n}\n.el-dialog__headerbtn {\n  top: 12px !important\n}\n.el-dialog__headerbtn .el-dialog__close {\n  color: white;\n}\n", ""]);

// exports
